import { _ } from '@ngx-translate/core';

import { ButtonThemePalette, buttonThemePalette } from '../button';
import type { Icon } from '../icon';

// TODO either this or AbsenceStatus in absence.model.ts should be removed
export type StatusIconType = 'Approved' | 'Declined' | 'Pending';

type StatusMapping = {
  [key in StatusIconType]: {
    icon: Icon;
    button: buttonThemePalette;
    label: string;
  };
};

export const statusMapping: StatusMapping = {
  Approved: {
    icon: 'check',
    button: ButtonThemePalette.green,
    label: _('Approved'),
  },
  Declined: {
    icon: 'times',
    button: ButtonThemePalette.red,
    label: _('Declined'),
  },
  Pending: {
    icon: 'ellipsis-h',
    button: ButtonThemePalette.secondary,
    label: _('Pending'),
  },
};
